import React from 'react';
import get from 'lodash/get';
import { GenericCheckbox } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isCheck } from '../../../utils/validation';
const PaymentCredited = ({ values }) => {
  const selectedID = values.paymentCameFrom !== null ? get(values, 'paymentCameFrom', []) : [];
  return (
    <Content>
      {({
        accountDetailsPaymentCameTitle = '',
        accountDetailsCheckBoxCommision = '',
        accountDetailsCheckBoxRentalPayments = '',
        accountDetailsCheckBoxRoyalties = '',
        accountDetailsCheckBoxTransfer = '',
        accountDetailsCheckBoxConsultancyFee = '',
        accountDetailsCheckBoxProfessionalFee = '',
        accountDetailsCheckBoxSalesCustomer = '',
        accountDetailCreditedPageError = '',
        accountDetailsPaymentCameTitleHelpText = '',
        accountDetailsCheckBoxCommisionValue = '',
        accountDetailsCheckBoxRentalPaymentsValue = '',
        accountDetailsCheckBoxRoyaltiesValue = '',
        accountDetailsCheckBoxTransferValue = '',
        accountDetailsCheckBoxConsultancyFeeValue = '',
        accountDetailsCheckBoxProfessionalFeeValue = '',
        accountDetailsCheckBoxSalesCustomerValue = ''
      }) => (
        <Field
          name="paymentCameFrom"
          subscription={{ touched: true, error: true }}
          validate={isCheck}
        >
          {({ meta: { touched, error }, input }) => (
            <GenericFieldWrapper
              inputId="paymentCameFrom"
              title={accountDetailsPaymentCameTitle}
              validationMessage={touched && !!error ? accountDetailCreditedPageError : ''}
              description={accountDetailsPaymentCameTitleHelpText}
            >
              <GenericCheckbox.StackedSet
                {...input}
                items={[
                  {
                    id: accountDetailsCheckBoxCommisionValue,
                    labelText: accountDetailsCheckBoxCommision
                  },
                  {
                    id: accountDetailsCheckBoxRentalPaymentsValue,
                    labelText: accountDetailsCheckBoxRentalPayments
                  },
                  {
                    id: accountDetailsCheckBoxRoyaltiesValue,
                    labelText: accountDetailsCheckBoxRoyalties
                  },
                  {
                    id: accountDetailsCheckBoxTransferValue,
                    labelText: accountDetailsCheckBoxTransfer
                  },
                  {
                    id: accountDetailsCheckBoxConsultancyFeeValue,
                    labelText: accountDetailsCheckBoxConsultancyFee
                  },
                  {
                    id: accountDetailsCheckBoxProfessionalFeeValue,
                    labelText: accountDetailsCheckBoxProfessionalFee
                  },
                  {
                    id: accountDetailsCheckBoxSalesCustomerValue,
                    labelText: accountDetailsCheckBoxSalesCustomer
                  }
                ]}
                groupName="paymentCameFrom"
                onChange={selectedIds => {
                  input.onChange(selectedIds);
                }}
                selectedIds={selectedID}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      )}
    </Content>
  );
};

export default PaymentCredited;
